console.log("GSAP TEXT IMAGE STATS LOADED");

document.addEventListener("DOMContentLoaded", () => {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  document
    .querySelectorAll("[data-gsap-text-image-stats]")
    .forEach((section) => {

      const imageBase   = section.querySelector(".ti-stats__image--base");
      const imageOverlay = section.querySelector(".ti-stats__image--overlay");
      const bgNumber    = section.querySelector(".ti-stats__bg-number");
      const counters    = section.querySelectorAll("[data-count]");

      if (!imageBase) return;

      const pinDuration = window.innerHeight * 0.35;

      /* =========================
         ÉTATS INITIAUX
      ========================= */

      gsap.set(imageBase, { opacity: 1 });

      if (imageOverlay) {
        gsap.set(imageOverlay, { opacity: 0 });
      }

      if (bgNumber) {
        gsap.set(bgNumber, {
          xPercent: 5,
          opacity: 0.01,
          willChange: "transform"
        });
      }
      gsap.set(section, {
        "--mask-stop": "0%"
      });

      ScrollTrigger.create({
        trigger: section,
        start: "top+=1% 35%",      
        end: "top+=2% 3%",        
        scrub: true,
        // markers: true,
        onUpdate: (self) => {
          gsap.set(section, {
            "--mask-stop": `${self.progress * 2}%`
          });
        },
        onLeave: () => {
          gsap.set(section, {
            "--mask-stop": "0%"
          });
        },
        onLeaveBack: () => {
          gsap.set(section, {
            "--mask-stop": "0%"
          });
        }
      });
      /* =========================
         TIMELINE SCROLL (EXISTANT)
      ========================= */

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "center-=15% center-=10%",
          end: `+=${pinDuration}`,
          pin: true,
          pinSpacing: true,
          scrub: true,
          anticipatePin: 1,
          // markers: true
        }
      });

      if (imageOverlay) {
        tl.to(imageOverlay, {
          opacity: 1,
          ease: "none"
        }, 0.3);
      }

      if (bgNumber) {
        tl.to(bgNumber, {
          xPercent: 0,
          opacity: 0.2,
          ease: "power2.out"
        }, 0.45);
      }

      /* =========================
         🔢 COMPTEURS (AJOUT)
      ========================= */

      if (counters.length) {
        ScrollTrigger.create({
          trigger: section,
          // start: "top 65%",
          start: "center-=15% center-=10%",
          once: true,
          onEnter: () => {
            counters.forEach((el, index) => {
              const target = parseInt(el.dataset.count, 10);
              if (isNaN(target)) return;

              gsap.fromTo(
                el,
                { innerText: 0 },
                {
                  innerText: target,
                  duration: 1.2 + index * 0.15, 
                  ease: "power2.out",
                  snap: { innerText: 1 },
                  onUpdate: () => {
                    const value = Math.floor(el.innerText);
                    const suffix = el.dataset.suffix || "";
                    el.innerText = `${value}${suffix}`;
                  },
                  onComplete: () => {
                    const suffix = el.dataset.suffix || "";
                    el.innerText = `${target}${suffix}`;
                  }
                }
              );
            });
          }
        });
      }

    });
});
